module.exports = __webpack_public_path__ + "static/media/songkick.fb7d184c.png";